import { debug } from "../utils";

export const ACTION_DEVICES_CHANGED = "ACTION_DEVICES_CHANGED";
export const ACTION_GROUPS_CHANGED = "ACTION_GROUPS_CHANGED";
export const ACTION_GROUP_CHANGED = "ACTION_GROUPS_LOADED";
export const ACTION_DEVICES_CHANGED_GET_ALL_DEVICES = 'ACTION_DEVICES_CHANGED_GET_ALL_DEVICES'


export function DevicesPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_DEVICES_CHANGED_GET_ALL_DEVICES: {
            return { ...state, ...action.payload };
        }
        case ACTION_DEVICES_CHANGED: {
            debug(`DevicesPageReducer ${ACTION_DEVICES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_GROUPS_CHANGED: {
            debug(`DevicesPageReducer ${ACTION_GROUPS_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_GROUP_CHANGED: {
            debug(`DevicesPageReducer ${ACTION_GROUP_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}
